import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
Swiper.use([Navigation, Pagination]);
import SliderPlugin from './slider-plugin';

class ImageSliderPlugin extends SliderPlugin {

    static type: String = "images";

    constructor(element: HTMLElement) {
        super(element);
    }

    init() {
        let buttons = this.getButtons();

        this.swiper = new Swiper(this.getClassPath(), {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: false,
            pagination: {
                el: buttons.pagiBtn,
                clickable: true,
            },
            navigation: {
                nextEl: buttons.nextBtn,
                prevEl: buttons.prevBtn,
            },
        });
        this.swiper.on('slideChange', function () {
            window.lazyload.update();
        });
    }

}

export default ImageSliderPlugin;